import { PartNo } from "../contexts/types";

/**
 * 過去プロジェクトの Part No のうち、本プロジェクトに含まれない Part No を返す。
 *
 * @param capexPartNo 本プロジェクトの Part No 情報
 * @param pastCapexPartNo 過去プロジェクトの Part No 情報
 * @returns 本プロジェクトに含まれない過去プロジェクトの Part No 一覧（不整合なしの場合は空配列）
 */
export const findMissingPastPartNos = (
  capexPartNo: PartNo[] | null | undefined,
  pastCapexPartNo: PartNo[] | null | undefined
): string[] => {
  const currentSet = new Set((capexPartNo ?? []).map(p => p.partNo));
  return (pastCapexPartNo ?? [])
    .filter(past => past.partNo && !currentSet.has(past.partNo))
    .map(past => past.partNo as string);
};
